import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

export const OnRouteChange = (props: any) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);

    // Track page views
    trackPageView({
      title: 'CNV Auction',
      referrer: document?.referrer,
      pageUrl: window?.location?.href,
      path: location?.pathname,
    });
  }, [location.pathname]);

  return <>{props.children}</>;
};
